import { render, staticRenderFns } from "./UpgradeIcon.vue?vue&type=template&id=368c9696&scoped=true&"
import script from "./UpgradeIcon.vue?vue&type=script&lang=js&"
export * from "./UpgradeIcon.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeIcon.vue?vue&type=style&index=0&id=368c9696&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368c9696",
  null
  
)

export default component.exports